import { MyJournalState } from "./my-journal.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

// Selector functions
const myJournalSelector =
  createFeatureSelector<MyJournalState>('ss-cord.my-journal');


export const GetDailyMealsList = createSelector(myJournalSelector, (state) => ({ loading: state.loading, list: state.foodIntake, totalRl: state.totalRl }));

export const GetDailyPhysicalActivity = createSelector(myJournalSelector, (state) => (({ loading: state.loading, list: state.physicalActivity, totalPa: state.totalPa })));

export const GetDailyScreenTime = createSelector(myJournalSelector, (state) => (({ loading: state.loading, list: state.screenTimeActivity, totalSt: state.totalSt })));

export const GetSearchedDailyMealList = createSelector(myJournalSelector, (state) => state.searchedDailyMeal);

export const GetSearchedPhysicalActivityList = createSelector(myJournalSelector, (state) => state.searchedDailyPhysical);

export const GetWeekDetails = createSelector(myJournalSelector, state => state.weekDetails)

export const GetMealType = createSelector(myJournalSelector, state => state.mealType)

export const GetTodType = createSelector(myJournalSelector, state => state.todType)

export const GetColorType = createSelector(myJournalSelector, state => state.colorType)

export const GetScreenType = createSelector(myJournalSelector, state => state.screenType)

export const GetActivityType = createSelector(myJournalSelector, state => state.activityType)
